import React, { forwardRef, memo } from 'react';
import classNames from 'classnames';

import IconChevronDown from '@zvuk-b2b/react-uikit/ui/icons/ChevronDown';

import type { ReportSelectTriggerProps } from './types';

import styles from './index.module.scss';

const ReportSelectTrigger = forwardRef<HTMLButtonElement, ReportSelectTriggerProps>(
  (
    {
      ariaLabelledBy,
      count,
      countTestId,
      dropdownId,
      elementId,
      iconTestId,
      isOpen,
      testId,
      textTestId,
      title,
      titleTestId,
      onClick,
    },
    ref
  ) => (
    <button
      id={elementId}
      type="button"
      ref={ref}
      className={classNames(styles.trigger, {
        [styles.triggerOpen]: isOpen,
      })}
      data-testid={testId}
      aria-controls={dropdownId}
      aria-expanded={isOpen}
      aria-labelledby={ariaLabelledBy}
      onClick={onClick}>
      <span
        className={styles.triggerText}
        data-testid={textTestId}>
        <span
          id={titleTestId}
          className={styles.triggerTitle}
          data-testid={titleTestId}>
          {title}
        </span>
        <span
          id={countTestId}
          className={styles.triggerCount}
          data-testid={countTestId}>
          {count}
        </span>
      </span>
      <span
        className={classNames(styles.triggerIcon, {
          [styles.triggerIconOpen]: isOpen,
        })}
        data-testid={iconTestId}>
        <IconChevronDown />
      </span>
    </button>
  )
);

ReportSelectTrigger.displayName = 'ReportSelectTrigger';

export default memo(ReportSelectTrigger);
